import { IMAGES } from "../../data/content";

export const Hero = () => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative border-b border-neutral-800"
  >
    <div className="absolute inset-0">
      <img
        src={IMAGES.heroCar}
        alt="Subaru Impreza 555 della Legend Team in traversa durante una prova speciale"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-neutral-950/80" />
    </div>
    <div className="relative py-24 sm:py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="kinetic-hero">
        <div className="mono-label text-xs uppercase tracking-widest text-red-500 font-bold mb-4">
          Motorsport Club & Scuola Guida &bull; Sant'Agata Feltria &bull; dal 2003 con Finnico Corse
        </div>
        <h1 className="font-display text-6xl sm:text-8xl lg:text-9xl font-black uppercase leading-none text-white tracking-tighter mb-8">
          Benvenuti nella Legend Team
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <p
              data-testid="hero-differentiator"
              className="text-xl sm:text-2xl text-neutral-300 font-light leading-relaxed"
            >
              Dalle prove speciali di Davide "Il Finnico" Bolognesi alla scuderia Finnico
              Corse, fino al Legend Team: gara, officina, club storico, formazione ed eventi
              con radici profonde nell'Appennino di Sant'Agata Feltria.
            </p>
            <p
              data-testid="hero-quote"
              className="mono-label text-xs sm:text-sm text-neutral-500 uppercase tracking-wider mt-5"
            >
              "Grandi sogni che, con enormi sacrifici, si stanno realizzando. Chi ci segue vedrà."
              <span className="text-red-500"> — Davide Bolognesi</span>
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <a
              data-testid="hero-cta"
              href="#contact"
              className="w-full sm:w-auto text-center px-8 py-4 bg-red-600 hover:bg-red-500 text-white font-black uppercase text-sm tracking-widest transition-transform hover:-translate-y-0.5"
            >
              Richiedi Info o Iscriviti
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
